const COMMON_CONFIG = {
	width: 479,
	gapX: 28,
	gapY: 30
};
// accommodates 2-line title (~40px) + heading padding (26px) + border (2px) ≈ 68px
const COMPACT_CARD_HEIGHT = 70;

export default {
	view: {
		extended: {
			columns: COMMON_CONFIG,
			flowCard: {
				width: COMMON_CONFIG.width,
				height: 300,
				bodyViewHeight: 600
			}
		},
		compact: {
			columns: COMMON_CONFIG,
			flowCard: {
				width: COMMON_CONFIG.width,
				height: COMPACT_CARD_HEIGHT
			}
		},
		marginTop: 78
	}
} as const;
